function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

export function scrollTo(elm, left) {
  var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (!elm) return;

  if (elm.scrollTo) {
    return _typeof(left) === 'object' ? elm.scrollTo(left) : elm.scrollTo(left, top);
  }

  var _ref = _typeof(left) === 'object' ? left : {
    top: top,
    left: left
  },
      scrollTop = _ref.top,
      scrollLeft = _ref.left;

  if (scrollTop) elm.scrollTop = scrollTop;
  if (scrollLeft) elm.scrollLeft = scrollLeft;
}